<template>
  <div class="dice-container">
    <template v-if="number === 1">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M48.24,1.76A5.94,5.94,0,0,0,44,0H6A6,6,0,0,0,0,6V44a6,6,0,0,0,6,6H44a6,6,0,0,0,6-6V6A5.94,5.94,0,0,0,48.24,1.76ZM28.54,28.54,25,32.07l-3.54-3.53L17.93,25l3.53-3.54L25,17.93l3.54,3.53L32.07,25Z"/></svg>
    </template>
    <template v-if="number === 2">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M48.24,1.76A5.94,5.94,0,0,0,44,0H6A6,6,0,0,0,0,6V44a6,6,0,0,0,6,6H44a6,6,0,0,0,6-6V6A5.94,5.94,0,0,0,48.24,1.76ZM18,39,14.5,42.57,11,39,7.43,35.5,11,32l3.54-3.53L18,32l3.53,3.54ZM39,18,35.5,21.57,32,18,28.43,14.5,32,11,35.5,7.43,39,11l3.53,3.54Z"/></svg>
    </template>
    <template v-if="number === 3">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M48.24,1.76A5.94,5.94,0,0,0,44,0H6A6,6,0,0,0,0,6V44a6,6,0,0,0,6,6H44a6,6,0,0,0,6-6V6A5.94,5.94,0,0,0,48.24,1.76ZM17,40,13.5,43.57,10,40,6.43,36.5,10,33l3.54-3.53L17,33l3.53,3.54Zm11.5-11.5L25,32.07l-3.54-3.54L17.93,25l3.53-3.54L25,17.93l3.54,3.53L32.07,25ZM40,17,36.5,20.57,33,17,29.43,13.5,33,10,36.5,6.43,40,10l3.53,3.54Z"/></svg>
    </template>
    <template v-if="number === 4">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M48.24,1.76A5.94,5.94,0,0,0,44,0H6A6,6,0,0,0,0,6V44a6,6,0,0,0,6,6H44a6,6,0,0,0,6-6V6A5.94,5.94,0,0,0,48.24,1.76ZM17,40,13.5,43.57,10,40,6.43,36.5,10,33l3.54-3.53L17,33l3.53,3.54Zm0-23L13.5,20.57,10,17,6.43,13.5,10,10,13.5,6.43,17,10l3.53,3.54ZM40,40,36.5,43.57,33,40,29.43,36.5,33,33l3.54-3.53L40,33l3.53,3.54Zm0-23L36.5,20.57,33,17,29.43,13.5,33,10,36.5,6.43,40,10l3.53,3.54Z"/></svg>
    </template>
    <template v-if="number === 5">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M48.24,1.76A5.94,5.94,0,0,0,44,0H6A6,6,0,0,0,0,6V44a6,6,0,0,0,6,6H44a6,6,0,0,0,6-6V6A5.94,5.94,0,0,0,48.24,1.76ZM10,10,13.5,6.43,17,10l3.53,3.54L17,17,13.5,20.57,10,17,6.43,13.5ZM17,40,13.5,43.57,10,40,6.43,36.5,10,33l3.54-3.53L17,33l3.53,3.54Zm8-8-3.54-3.53L17.93,25l3.53-3.54L25,17.93l3.54,3.53L32.07,25l-3.53,3.54Zm15,8L36.5,43.57,33,40,29.43,36.5,33,33l3.54-3.53L40,33l3.53,3.54Zm0-23L36.5,20.57,33,17,29.43,13.5,33,10,36.5,6.43,40,10l3.53,3.54Z"/></svg>
    </template>
    <template v-if="number === 6">
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><path d="M48.24,1.76A5.94,5.94,0,0,0,44,0H6A6,6,0,0,0,0,6V44a6,6,0,0,0,6,6H44a6,6,0,0,0,6-6V6A5.94,5.94,0,0,0,48.24,1.76ZM17.68,42.68,14.5,45.86l-3.18-3.18L8.14,39.5l3.18-3.18,3.18-3.18,3.18,3.18,3.18,3.18Zm0-14.5L14.5,31.36l-3.18-3.18L8.14,25l3.18-3.18,3.18-3.18,3.18,3.18L20.86,25Zm0-14.5L14.5,16.86l-3.18-3.18L8.14,10.5l3.18-3.18L14.5,4.14l3.18,3.18,3.18,3.18Zm21,29L35.5,45.86l-3.18-3.18L29.14,39.5l3.18-3.18,3.18-3.18,3.18,3.18,3.18,3.18Zm0-14.5L35.5,31.36l-3.18-3.18L29.14,25l3.18-3.18,3.18-3.18,3.18,3.18L41.86,25Zm0-14.5L35.5,16.86l-3.18-3.18L29.14,10.5l3.18-3.18L35.5,4.14l3.18,3.18,3.18,3.18Z"/></svg>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="css" scoped>
.dice-container {
  width: 28px;
  height: 28px;
  margin: 5px;
  display: inline;
}

svg {
  margin-top: -15px;
  width: 28px;
  fill: var(--primary-color);
}
</style>
